import React from "react";
import { Image, Box, Text } from "@chakra-ui/react";

import { useIsMobile } from "../default/ResponsiveUtils";

const ImageSlide = ({ image, description }) => {
  const isMobile = useIsMobile();

  return (
    <Box position="relative">
      <Image src={image} width="60rem" height="35rem" justifySelf="center" />
      {description && (
        <Box
          position="absolute"
          top="65%"
          width="50%"
          pl="3%"
          pr="1%"
          bg="#44838d"
          border="4px solid #2e6d75"
        >
          <Text
            fontSize={isMobile ? 20 : 36}
            fontFamily="serif"
            fontWeight="bold"
            overflowWrap="break-word"
            textColor="#edf4f5"
          >
            {description}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default ImageSlide;
